import { logger } from 'packages/logger';

const copy = (element) => {
    let successful = false;
    if (window.getSelection) {
        // all browsers, except IE before version 9
        const selection = window.getSelection();
        const rangeToSelect = document.createRange();
        rangeToSelect.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(rangeToSelect);

        try {
            successful = document.execCommand('copy');
            if (successful && selection) {
                selection.removeAllRanges();
            }
        } catch (err) {
            alert('Tryck Ctrl/Cmd+C för att kopiera');
            logger(err);
        }
    }
    return successful;
};

const isSupportedInBrowser = () =>
    document.queryCommandSupported && document.queryCommandSupported('copy');

export default {
    copy,
    isSupportedInBrowser
};
